import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {
  BASIC_CLIENT_INFO,
  PENSION_EN_TRAMITE,
} from "@constants/data-service.constant";
import { PENSION_PROCESS_RESPONSE } from "@constants/tramite-pension-constant";
import { INICIO, VIDEO_ATENCION } from "@constants/url.constant";
import { GtmService } from "@services/gtm/gtm.service";
import { StorageService } from "@services/storage/storage.service";
import { Util } from "@shared/common/utils/util";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { TramitePensionService } from "../../services/tramite-pension.service";

@Component({
  selector: "app-voucher-pension",
  templateUrl: "./voucher-pension.component.html",
  styleUrls: ["./voucher-pension.component.scss"],
  standalone: false
})
export class VoucherPensionComponent {
  applicationData: {
    email: string;
    RequestNumber: string;
    typeApplication: string;
    longDate: string;
  };
  state: "success" | "error" = "success";
  showMessage = false;
  isLoadingPdf = false;
  title: string = "";
  constructor(
    private readonly location: Location,
    private readonly router: Router,
    private readonly util: Util,
    private readonly storageService: StorageService,
    private readonly tramitePensionService: TramitePensionService,
    private readonly gtmService: GtmService,
  ) {
    this.inicializar();
  }


  private inicializar() {
    void this.initialize();
  }

  async initialize() {
    this.applicationData = {
      email: "",
      RequestNumber: "",
      typeApplication: "Pensión por vejez",
      longDate: "",
    };

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.applicationData.RequestNumber =
        navigation.extras.state["numeroSolicitud"];
      const email = await this.storageService.get("client_email");
      this.applicationData.email = email;
      this.applicationData.longDate = this.util.getLongFormattedDate();
    }
    const infoTramitePension = await this.buildTramiteEnProceso();
    this.storageService.set(
      PENSION_PROCESS_RESPONSE,
      infoTramitePension
    );
    this.storageService.set(PENSION_EN_TRAMITE, true);

    setTimeout(() => {
      this.util.levantarEncuesta('tramite-pension-vejez');
    }, 1000);
  }

  goBack() {
    this.location.back();
  }
  async downloadVoucher() {
    this.isLoadingPdf = true;
    try {
      this.gtmService.trackClick('button', 'Descargar comprobante', 'boton_principal', '');

      const base64: any = await this.tramitePensionService
        .createPdf(await this.buildPDFData())
        .toPromise();
      this.util.downloadMyFile(base64.toString("base64"), "tramite-pension");
      this.state = "success";
      this.title = "Tu comprobante fue descargado con éxito";
      this.showMessage = true;
    } catch (error) {
      console.log("Error downloading voucher:", error);
      this.state = "error";
      this.showMessage = true;
      this.title = "Ocurrió un error al descargar tu comprobante";
      return;
    }
    this.isLoadingPdf = false;
  }
  async buildPDFData() {

    const response = await firstValueFrom(this.tramitePensionService.getPersonalData());

    const rut = await this.tramitePensionService.uid();
    return {
      templateName: "tramite-pension",
      datos: {
        tp: {
          folio: this.applicationData.RequestNumber,
          nombre: `${response.nombres}, ${response.apellidoPaterno} ${response.apellidoMaterno}`,
          rut: this.util.stringToFormattedRut(rut),
          domicilio: `${response.direccion}, ${response.comuna}, ${response.region}`,
          correo: await this.storageService.get("client_email"),
          fecha_solicitud: this.applicationData.longDate,
        },
      },
    };
  }
  closeMessage() {
    this.showMessage = false;
  }
  goToHome() {
    this.router.navigate([INICIO]);
  }

  async buildTramiteEnProceso() {
    const response = await firstValueFrom(this.tramitePensionService.getPersonalData());


    const rut = await this.tramitePensionService.uid();
    const basicInfo = await this.storageService.get(BASIC_CLIENT_INFO);
    const pension = {
      PensionesEnTramite: [
        {
          descripcionTipoTramite: "Vejez Edad",
          nombreAfiliado: `${response.nombres}, ${response.apellidoPaterno} ${response.apellidoMaterno}`,
          rutAfiliado: this.util.stringToFormattedRut(rut),
          fechaSolicitudTramite: this.util.formattedTodayDDMMYYYY(),
          sexo: basicInfo.gender,
          indicadorMandatario: "N",
          numeroTramite: String(this.applicationData.RequestNumber ?? ""),
        },
      ],
    };
    return pension;
  }

  goToVideoAtencion() {
    this.router.navigate([`/${VIDEO_ATENCION}`]);
  }
}
